import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const swatches = [
  { name: 'Noir double', bg: 'bg-[#1a1a1a]' },
  { name: 'Brun chocolat', bg: 'bg-[#4a3b2a]' },
  { name: 'Gris ardoise', bg: 'bg-[#5a6a7a]' },
  { name: 'Cèdre rustique', bg: 'bg-[#8b6f4e]' },
  { name: 'Vert forêt', bg: 'bg-[#3d5c3a]' },
  { name: 'Bleu nuit', bg: 'bg-[#1e3a5f]' },
  { name: 'Sable désert', bg: 'bg-[#b8a070]' },
  { name: 'Brun harvest', bg: 'bg-[#6b4226]' },
];

export default function Couleurs() {
  const { t } = useTranslation('bardeau');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="couleurs" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-10 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-3">
            {t('couleurs_h2')}
          </h2>
        </div>

        <div
          className={`grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-8 gap-4 md:gap-5 mb-8 transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {swatches.map((swatch, idx) => (
            <div
              key={idx}
              className="text-center transition-all duration-700"
              style={{ transitionDelay: `${idx * 80 + 200}ms` }}
            >
              <div
                className={`w-full aspect-square rounded-xl ${swatch.bg} mb-2 shadow-sm`}
              />
              <span className="text-slate-primary text-xs font-medium">{swatch.name}</span>
            </div>
          ))}
        </div>

        <p
          className={`text-center text-slate-primary/50 text-xs md:text-sm max-w-2xl mx-auto transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {t('couleurs_note')}
        </p>
      </div>
    </section>
  );
}